<div class="file-breadcrumb">
  <button
    class="crumb"
    [ngClass]="{ link: paths?.length }"
    (activate)="jumpTo(0, true)"
    >Files and Folders</button>
  <ng-container *ngFor="let path of paths; let i = index">
    <span>
      <i class="far fa-chevron-right arrow"></i>
    </span>
    <button tabindex="0" class="crumb link" (activate)="jumpTo(i)">{{ path }}</button>
  </ng-container>
</div>
